// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1ZjvM","footer":"ModalError_footer__3T3lv"};